import { Fragment, ReactNode } from "react";
import { useWorkspaceId } from "@/lib/hooks/use-workspace-id";

/**
 * Remounts the wrapped subtree whenever the active workspace changes.
 *
 * Workspace switching is reactive (no page reload — see AppSidebar), so an
 * entity grid's in-memory view state (search query, saved-search selection,
 * active filters, active list / client-side list membership) would otherwise
 * carry over to the new workspace and filter its freshly-loaded rows down to
 * zero — the "No People Found until refresh" bug. Keying on the workspace id
 * gives the page a fresh mount (identical to a browser refresh) on every switch,
 * while the surrounding layout (sidebar, providers) stays mounted.
 */
export function WorkspaceRemount({ children }: { children: ReactNode }) {
  const workspaceId = useWorkspaceId();
  return <Fragment key={workspaceId ?? "no-workspace"}>{children}</Fragment>;
}

export default WorkspaceRemount;
